(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("karcherReportActions", karcherReportActionsFactory);

  /** @ngInject */
  function karcherReportActionsFactory($q, api, dispatcher, ActionTypesEnum) {
    return {
      getWashFacilityBoxesByWashFacilityId:
        getWashFacilityBoxesByWashFacilityId,
      getWashFacilityShortList: getWashFacilityShortList,
      getJetwashReportWorkingHoursPerProgram:
        getJetwashReportWorkingHoursPerProgram,
      getJetwashReportTurnoverPerBay: getJetwashReportTurnoverPerBay,
      getRolloverReportWashesPerProgram: getRolloverReportWashesPerProgram,
      getRolloverReportTurnover: getRolloverReportTurnover,
      getJetwashReportTurnoverPerChannel: getJetwashReportTurnoverPerChannel
    };

    function getWashFacilityBoxesByWashFacilityId(washFacilityId) {
      var deferred = $q.defer();
      api.getWashFacilityBoxesByWashFacilityId(washFacilityId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getWashFacilityShortList() {
      var deferred = $q.defer();
      api.getWashFacilityShortList().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getJetwashReportWorkingHoursPerProgram(data) {
      var deferred = $q.defer();
      api.getJetwashReportWorkingHoursPerProgram(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getJetwashReportTurnoverPerBay(data) {
      var deferred = $q.defer();
      api.getJetwashReportTurnoverPerBay(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getRolloverReportWashesPerProgram(data) {
      var deferred = $q.defer();
      api.getRolloverReportWashesPerProgram(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getRolloverReportTurnover(data) {
      var deferred = $q.defer();
      api.getRolloverReportTurnover(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getJetwashReportTurnoverPerChannel(data) {
      var deferred = $q.defer();
      api.getJetwashReportTurnoverPerChannel(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }
  }
})();
